<div class="sessions-container">
  <div class="sessions-header">
    @if (!loading && (sessions$ | async)?.length) {
      <button
        id="tour-revoke-sessions"
        class="revoke-btn"
        (click)="onRevokeAllSessions($event)"
        title="Revoke all active sessions"
      >
        Revoke All Sessions
      </button>
    }
  </div>

  @if (loading) {
    <div class="loading">Loading sessions...</div>
  } @else {
    @if ((groupedSessions$ | async)?.length ?? 0 > 0) {
      <div class="device-groups">
        @for (
          group of groupedSessions$ | async;
          let i = $index;
          track group.deviceType
        ) {
          <div class="device-group">
            <div
              [id]="'tour-device-group-' + i"
              class="device-group-header"
              (click)="toggleDeviceGroup(group.deviceType)"
              (keydown)="toggleDeviceGroup(group.deviceType)"
              tabindex="0"
              role="button"
            >
              <div class="device-info">
                <div class="device-icon">{{ group.deviceIcon }}</div>
                <div class="device-details">
                  <div class="device-title">
                    {{ group.count }} session{{ group.count > 1 ? "s" : "" }} on
                    {{ group.deviceType }}
                  </div>
                  <div class="device-subtitle">
                    @for (
                      session of group.sessions | slice: 0 : 3;
                      track session.session_id;
                      let i = $index;
                      let last = $last
                    ) {
                      <span>{{
                        getCleanDeviceInfo(session, group.deviceType)
                      }}</span>
                      @if (!last && i < 2) {
                        <span>, </span>
                      }
                    }
                    @if (group.sessions.length > 3) {
                      <span>...</span>
                    }
                  </div>
                </div>
              </div>
              <div
                class="expand-icon"
                [class.expanded]="isDeviceGroupExpanded(group.deviceType)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 7.5L10 12.5L15 7.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            @if (isDeviceGroupExpanded(group.deviceType)) {
              <div class="sessions-list">
                @for (
                  session of group.sessions;
                  let i = $index;
                  track session.session_id
                ) {
                  <div class="session-item" [id]="'tour-session-item-' + i">
                    <div class="session-main-info">
                      <div class="session-device">
                        {{ getCleanDeviceInfo(session, group.deviceType) }}
                      </div>
                      <div class="session-metadata">
                        <span class="session-location">{{
                          formatIpAddress(session.ip_address)
                        }}</span>
                        <span class="session-divider">•</span>
                        <span class="session-time">{{
                          getRelativeTime(session.last_used_at)
                        }}</span>
                        <span class="session-divider">•</span>
                        <span class="session-browser">{{
                          getBrowserName(session.user_agent)
                        }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="no-sessions">No active sessions.</div>
    }
  }
</div>

@if (showRevokeConfirmDialog) {
  <app-popup
    heading="Revoke All Sessions"
    confirmText="Revoke"
    cancelText="Cancel"
    (confirmClicked)="onConfirmRevoke()"
    (cancelClicked)="onCancelRevoke()"
  >
    <p>
      @if (!userId) {
        Are you sure you want to revoke all sessions? This will also revoke the
        current session and you will have to login again.
      } @else {
        Are you sure you want to revoke all sessions for this user? This action
        cannot be undone.
      }
    </p>
  </app-popup>
}
